module.exports = __webpack_public_path__ + "media/kolf.d391a6a3.wav";